package com.esoris.kmpmoout.app.supabase

import org.koin.dsl.module

val supabaseModule = module {

    single {
        SupabaseFactory.client
    }
}